import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const jsonLdBreadcrumb = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://readdy.ai/' },
    { '@type': 'ListItem', position: 2, name: '关于我们' },
  ],
};

const jsonLdAboutPage = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于我们 - 女性健康指南',
  description: '女性健康指南是一个专注于女性生殖健康科普的知识平台，致力于用通俗易懂的语言传播科学的女性生殖系统知识。',
  url: 'https://readdy.ai/about',
  inLanguage: 'zh-CN',
  about: {
    '@type': 'Organization',
    name: '女性健康指南',
    description: '专注于女性生殖健康科普的知识平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-123-4567',
      contactType: 'customer service',
      email: 'contact@womenshealthguide.com',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '朝阳区建国路88号健康大厦12层',
      addressLocality: '北京',
      addressCountry: 'CN',
    },
  },
};

export default function AboutPage() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdBreadcrumb) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdAboutPage) }} />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="relative w-full h-52 md:h-64 rounded-lg overflow-hidden mb-10">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20healthcare%20team%20illustration%2C%20warm%20feminine%20tones%20with%20peach%20and%20cream%2C%20professional%20medical%20environment%20concept%2C%20clean%20modern%20aesthetic%2C%20soft%20natural%20light%2C%20healing%20atmosphere&width=1200&height=500&seq=about-hero&orientation=landscape"
                alt="关于我们"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-6">
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-white">关于我们</h1>
              </div>
            </div>

            <div className="space-y-12">
              <div>
                <h2 className="font-heading text-xl font-bold text-foreground-800 mb-4">品牌介绍</h2>
                <div className="prose-custom text-foreground-600 leading-relaxed space-y-4 text-sm md:text-base">
                  <p>
                    「女性健康指南」是一个专注于女性生殖健康科普的知识平台。我们致力于用通俗易懂的语言，传播科学的女性生殖系统知识，帮助每一位女性更好地了解自己的身体，主动管理自身健康。
                  </p>
                  <p>
                    我们的内容团队由妇产科医生、内分泌专家和医学编辑组成，所有文章均经过专业审核，确保信息的准确性、科学性和时效性。我们严格遵循循证医学原则，所有医学建议均基于权威指南和最新研究证据。
                  </p>
                  <p>
                    我们相信，知识是最好的「疫苗」。当女性拥有足够的健康知识，就能做出更明智的健康决策，及早发现潜在问题，积极预防疾病，拥抱更健康、更自信的人生。
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="bg-background-100 rounded-lg p-6 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
                    <i className="ri-shield-check-line text-xl"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2">专业可信</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    内容由妇产科专家审核，严格遵循循证医学原则，确保每一条信息的科学性和准确性。
                  </p>
                </div>
                <div className="bg-background-100 rounded-lg p-6 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4">
                    <i className="ri-user-heart-line text-xl"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2">关爱女性</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    以女性为中心，用温暖易懂的语言传递知识，让每位女性都能轻松获取所需的健康信息。
                  </p>
                </div>
                <div className="bg-background-100 rounded-lg p-6 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                    <i className="ri-lightbulb-line text-xl"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2">持续更新</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    紧跟医学发展前沿，定期更新内容，为读者提供最新、最全面的生殖健康知识。
                  </p>
                </div>
              </div>

              <div>
                <h2 className="font-heading text-xl font-bold text-foreground-800 mb-4">联系方式</h2>
                <div className="bg-background-100 rounded-lg p-6 space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 flex-shrink-0">
                      <i className="ri-mail-line"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">电子邮箱</p>
                      <p className="text-sm text-foreground-700">contact@womenshealthguide.com</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 flex-shrink-0">
                      <i className="ri-phone-line"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">咨询热线</p>
                      <p className="text-sm text-foreground-700">400-123-4567</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 flex-shrink-0">
                      <i className="ri-map-pin-line"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">办公地址</p>
                      <p className="text-sm text-foreground-700">北京市朝阳区建国路88号健康大厦12层</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-secondary-50 rounded-lg p-6">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  <strong className="text-foreground-800">重要声明：</strong>
                  本站所有内容仅供健康科普参考，不构成任何医疗诊断、治疗建议或用药指导。如果您有健康问题或疑似症状，请务必及时前往正规医疗机构就诊，遵从执业医师的专业诊断和治疗方案。切勿依据本站内容自行诊断或延误就医。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}